import type {
  DeleteContractAttachmentMutationOptions,
  DeleteContractAttachmentVariables,
} from './types';

import { useMutation } from '@tanstack/react-query';

import { deleteContractAttachment } from './deleteContractAttachment';

/**
 * Custom hook for deleting a contract attachment.
 *
 * @param options - Additional options for the mutation.
 * @returns An object containing the mutation function and related properties.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Contracts/operation/delete_attachment_contracts__contract_id__attachments__att_id__delete
 */
export const useMutationDeleteContractAttachment = (
  options?: DeleteContractAttachmentMutationOptions,
) =>
  useMutation({
    mutationFn: async ({
      contractId,
      attachmentId,
    }: DeleteContractAttachmentVariables) =>
      deleteContractAttachment(contractId, attachmentId),
    ...options,
  });
